﻿import buttonLoader from '../utilities/buttonLoader.js';

var receiptModal = {};

receiptModal = {


  init: function () {
    var me = this;
    var receiptForm = document.getElementsByClassName('receiptForm')[0];
    var receiptLinks = document.getElementsByClassName('receipt__submitReceipt');

    if (receiptForm) {
      me.bind(receiptForm);
    }

    Array.prototype.forEach.call(receiptLinks, (link) => {

      link.addEventListener('click', function (e) {
        e.preventDefault();

        var contractId = link.getAttribute('data-contractId');

        var modal = document.getElementsByClassName('modal_receipt')[0];

        if (modal) {
          modal.classList.add('modal--show')

          receiptForm.querySelector('input[name=contractId]').value = contractId;

        }
      })

    });

  },

  bind: function (form) {
    var me = this;

    form.addEventListener('submit', function (e) {

      e.preventDefault();

      var m = form.querySelector('.alert');

      if (m) {
        m.remove();
      }

      me.submit(form);

    });
  },

  submit: function (form) {
    var me = this;

    var button = form.querySelector('button[type=submit]');

    buttonLoader.start(button);

    var data = new FormData(form);

    var xhr = new XMLHttpRequest();
    xhr.open(form.getAttribute("method"), form.getAttribute("action"));

    xhr.onload = function () {

      var resp = JSON.parse(xhr.response);

      if (xhr.status >= 200 && xhr.status < 300) {

        if (resp.success) {

          buttonLoader.reset(button);

          me.renderMessage(button, resp.message, 'success');

        } else {

          buttonLoader.reset(button);

          me.renderMessage(button, resp.message, 'error');
        }

      } else {

        buttonLoader.reset(button);

        me.renderMessage(button, 'Server error', 'error');
      }

    };

    xhr.send(data);
  },

  renderMessage: function (el, message, type) {
    el.insertAdjacentHTML('afterend', '<div class="alert ' + type + '">' + message + '</div>');

  }

};

receiptModal.initialize = function () {
  receiptModal.init();
};

module.exports = receiptModal;
